<template>
  <div class="clazz_manage" v-if="clazz">
    <van-notice-bar
      v-if="!clazz.is_improve_info"
      :scrollable="false"
      text="完善班级信息后班级会在发现页展示"
      left-icon="volume-o"
    />

    <div class="header bgwhite">
      <div class="title">{{ clazz.clazz_name }}</div>
      <van-icon class="ml1 highlight" name="edit" @click="gotoClazzManageDetail" />
    </div>

    <div class="subinfo">
      <div style="margin-bottom: 2px;">参与时间：{{ clazz.start_time_format2 }} ～ {{ clazz.end_time_format2 }}</div>
      <div>跑步天数：{{ clazz.run_days }}天 | 每天距离：{{ clazz.day_distance }}公里</div>
    </div>

    <div class="stat_panel bgwhite mt15">
      <div class="stat_panel_body">
        <div class="item" @click="gotoClazzUser">
          <div class="value">{{ clazz.user_num }}</div>
          <div class="label">班级成员</div>
        </div>
        <div class="item" @click="gotoClazzRecord">
          <div class="value">{{ clazz.record_num }}</div>
          <div class="label">累计打卡</div>
        </div>
      </div>
    </div>

    <div class="">
      <van-cell title="班级详情" is-link :to="'/clazz/' + clazz.uuid" />
      <van-cell title="打卡详情" is-link :to="'/join/clazz/' + clazz.uuid" />
      <van-cell title="班级排名" is-link :to="'/manage/clazz/' + clazz.uuid + '/rank'" />
      <van-cell title="班级邀请卡" is-link :to="`/clazz/poster?clazz_id=${clazz.uuid}`" />
      <!-- <van-cell title="班级规则" is-link :to="'/clazz/' + clazz.uuid + '/rule'" /> -->
      <!-- <van-cell title="问题帮助" is-link /> -->
    </div>

    <div style="width: 335px; margin-left: 20px; margin-top:50px;">
      <bottom-btn class="mt2" title="删除班级" :fixed="false" @click.native="onClickDelete" />
    </div>

  </div>
</template>

<script>
import { Icon, Cell, CellGroup, NoticeBar, Dialog, Toast } from 'vant'
import BottomBtn from '@/components/BottomBtn'
import { clazzSimpleInfo } from '@/api/clazz'
import { deleteClazz } from '@/api/clazz_manage'

export default {
  name: 'ClazzConsole',
  components: {
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    BottomBtn
  },
  data () {
    return {
      clazzId: null,
      clazz: null
    }
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(this.clazzId)
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzSimpleInfo(clazzId)
      if (!response.data.is_manager) {
        this.$router.replace('/explore')
        return false
      }
      this.clazz = response.data
    },
    gotoClazzManageDetail () {
      this.$router.push('/manage/clazz/' + this.clazz.uuid + '/detail')
    },
    gotoClazzUser () {
      this.$router.push('/manage/clazz/' + this.clazz.uuid + '/user')
    },
    gotoClazzRecord () {
      this.$router.push('/manage/clazz/' + this.clazz.uuid + '/record')
    },
    async onClickDelete () {
      Dialog.confirm({
        title: '删除班级',
        message: '确定删除该班级吗？'
      }).then(async () => {
        await this.onDelete()
      }).catch(() => {
      })
    },
    async onDelete () {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      await deleteClazz(this.clazzId)
      Toast.clear()
      this.$router.replace('/manage/clazz/list')
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_manage {
  // background-color: #f8f8f8;
  .header {
    height: 70px;
    padding: 10px 25px 0;
    display: flex;
    align-items: center;
    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .subinfo {
    padding: 0 25px 20px;
    font-size: 26px;
    color: #9c9c9c;
    margin-top: 10px;
    border-bottom: 1px solid #efefef;
  }
  .stat_panel {
    .stat_panel_header {
      font-size: 30px;
      padding: 20px 25px;
    }
    .stat_panel_body {
      height: 160px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item {
        width: 380px;
        font-size: 28px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        .value {
          font-size: 38px;
        }
        .label {
          color: #9c9c9c;
          font-size: 26px;
          margin-top: 5px;
        }
        &.link {
          color: #9c9c9c;
          font-size: 32px;
          width: 80px;
          padding: 0;
        }
      }
    }
  }
}
</style>
